import axios from 'axios';
import PatientDocumentHistoryView from 'components/clinical-data/PatientDocumentHistoryView';
import { DocumentActionButton } from 'components/clinical-data/RequiresActionDocumentList';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import LoaderComponent from 'components/LoaderComponent';
import React, { useRef, useState } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Modal } from 'semantic-ui-react';
import { getPatientDocumentHistory } from 'services/patientRecordServices';
import {
  PatientCdrDocumentDto,
  PatientDocumentTypeDto,
  PatientDto,
  PatientMedicalDocumentHistoryDto
} from 'ts-types/api.types';
import { withRouterWorkaround } from 'utils/workaroundUtils';

interface Props extends MessageSourceProps {
  document: PatientCdrDocumentDto;
  doctorsMap: { [id: string]: PatientDto };
  documentTypesMap: { [id: string]: PatientDocumentTypeDto };
  handleError: (errorData: any) => void;
}

const CdrDocumentHistoryModal = (props: Props) => {

  const {getMessage} = props;

  const cancelTokenSource = useRef(axios.CancelToken.source());

  const [loadingData, setLoadingData] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  const [documentHistory, setDocumentHistory] =
      useState([] as PatientMedicalDocumentHistoryDto[]);

  const [text, setText] =
      React.useState<string | undefined>(undefined);

  const openModal = () => {

    const {document} = props;

    const documentId = document.documentId;
    const patientId = document.patientId;

    setLoadingData(true);
    setModalOpen(true);
    getPatientDocumentHistory(patientId, documentId, cancelTokenSource.current)
        .then(response => {
          setDocumentHistory(response);
        })
        .catch((e: any) => {

          setModalOpen(false);

          e.response
          && e.response.data
          && props.handleError
          && props.handleError(e.response.data)
        })
        .finally(() => {
          setLoadingData(false);
        });
  }

  const closeModal = () => setModalOpen(false);

  if (loadingData) {
    return <LoaderComponent message="loading"/>;
  }

  return <>
    <DocumentActionButton
        iconName="history"
        popupMessage="patientRecord.patientDocument.documentHistory.title"
        onClick={openModal}
    />

    {
        modalOpen
        && <Modal
            open={modalOpen}
            onClose={closeModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {getMessage("patientRecord.patientDocument.documentHistory.title")}
          </Modal.Header>
          <FormModalContentContainer>
            <PatientDocumentHistoryView
                patientDocumentTypesMap={props.documentTypesMap}
                patientDocument={props.document}
                patientDocumentHistory={documentHistory}
                doctors={Object.values(props.doctorsMap)}
                onCloseModal={closeModal}
            />
          </FormModalContentContainer>
        </Modal>
    }
  </>;
}

export default withRouterWorkaround(
    withMessages(
        CdrDocumentHistoryModal));
